/* Package JSON Import will be here */
import React, { Fragment } from "react";
import { Table, Search, Checkbox } from "semantic-ui-react";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import moment from "moment";
import MultiSelect from "react-dropdown-select";
/* Package JSON Import will be here */

/* Project Import will be here */
import { Constants } from "../../../../src/config/appConstants";
import NoResultFound from "../../sharedComponent/noResultFound";
import "../../tmVoucher/tmVoucher.css";
/* Project Import will be here */

const TMVoucherTableComponent = (props) => {
  const itemRenderer = ({ item, props, methods }) => (
    <div key={item[props.valueField]} onClick={() => methods.addItem(item)}>
      <div style={{ margin: "10px", display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}>
        <Checkbox className="selectedTable mb5" checked={methods.isSelected(item)} />
        <label style={{ paddingTop: '3px' }}>{item[props.labelField]}</label>
      </div>
    </div>
  );


  const contentRenderer = ({ state }) => (
    <div className="attestationDropdown d-flex items-center gap-1">
      {state.values.length === 2 ?
        <Fragment>
          <Checkbox className="d-flex selectedTable" checked={true} />
          <label style={{ marginTop: '0.20rem' }}>All</label>
        </Fragment>
        : state.values[0]?.text}
    </div>
  )

  const HeaderText = ({ text }) => {
    return (
      <span style={{ height: "20px", display: "inline-block", width: "100%" }}>
        {text}
      </span>
    )
  }

  return (
    <Table className="ui celled table tmVoucherHeader" style={{ marginBottom: props.isShowRevisionModal ? "40px" : "0px" }}>
      <Table.Header className="header-bg">
        <Table.Row style={{ verticalAlign: 'top' }}>
          <Table.HeaderCell className="text-left voucherNumberSearch">
            <HeaderText text={"Voucher#"} />
            <Search
              onSearchChange={(e) => props.onSearchChange(e, Constants.TM_VOUCHER_NUMBER_SEARCH)}
              placeholder={Constants.SEARCH_PLACEHOLDER}
              value={props.voucherNumberSearchText}
            />
          </Table.HeaderCell>
          <Table.HeaderCell className="signatureSearch">
            <HeaderText text={"Signature"} />
            <MultiSelect
              className="attestationDropdownStyle"
              style={{ marginTop: '0.5em', height: "30px" }}
              options={props.signatureOptions}
              values={props.selectedSignatureTMVoucherOptions}
              keepSelectedInList={true}
              multi={true}
              labelField="text"
              valueField="id"
              closeOnSelect={false}
              searchable={false}
              onChange={(value) => props.onChangeSignature(value)}
              onDropdownClose={() => props.onSearchChange("", Constants.TM_VOUCHER_SIGNATURE_SEARCH)}
              itemRenderer={(item, itemIndex, props, state, methods) => itemRenderer(item, itemIndex, props, state, methods)}
              contentRenderer={(props, state) => contentRenderer(props, state)}
            />
          </Table.HeaderCell>
          <Table.HeaderCell className="text-left tMVoucherDownloadEYes">
            <HeaderText text={"T&M Report"} />
          </Table.HeaderCell>
          <Table.HeaderCell className="text-left attachmentColumnTM">
            <HeaderText text={"Attachments"} />
          </Table.HeaderCell>
          {!(props.isShowRevisionModal) &&
            <Table.HeaderCell className="text-left">
              <HeaderText text={"Revisions"} />
            </Table.HeaderCell>}
            <Table.HeaderCell className="text-left">
                <HeaderText text={"Employee Full Name"} />
                <Search
                    className="employeeFullNameSearch"
                    onSearchChange={(e) => props.onSearchChange(e, Constants.TM_VOUCHER_EMPOYLEE_SEARCH)}
                    placeholder={Constants.SEARCH_PLACEHOLDER}
                    value={props.employeeSearchText}
                />
            </Table.HeaderCell>
            <Table.HeaderCell className="text-left deviceNameSearch">
            <HeaderText text={"Device Name"} />
            <Search
              onSearchChange={(e) => props.onSearchChange(e, Constants.TM_VOUCHER_DEVICENAME_SEARCH)}
              placeholder={Constants.SEARCH_PLACEHOLDER}
              value={props.deviceNameSearchText}
            />
          </Table.HeaderCell>
          <Table.HeaderCell className="text-left dataSubmitted">
            <HeaderText text={"TimeCard Date"} />
            <MuiPickersUtilsProvider utils={DateFnsUtils} >
              <KeyboardDatePicker className="date-field tmvocherDateField"
                disabled={!props.isDatePickerEnabled}
                placeholder="MM/DD/YY"
                clearable
                value={props.tmVoucher && props.selectedTimecardDate ? props.selectedTimecardDate : null}
                onChange={date => props.handleTimecardDateChange(date)}
                inputProps={{ readOnly: true }}
                format="MM/dd/yy"
                inputVariant="outlined"
                {...(props.minDate ? props.minDate : {})}
                {...(props.maxDate ? props.maxDate : {})}
              />
            </MuiPickersUtilsProvider>
          </Table.HeaderCell>
          <Table.HeaderCell className="text-left projectNumberName">
            <HeaderText text={"Project Number - Name"} />
            <Search
              // className="theader"
              onSearchChange={(e) => props.onSearchChange(e, Constants.TM_VOUCHER_PROJECT_SEARCH)}
              placeholder={Constants.SEARCH_PLACEHOLDER}
              value={props.projectSearchText}
            />
          </Table.HeaderCell>
          <Table.HeaderCell className="text-left taskCodes">
            <HeaderText text={"Task Codes"} />
            <Search
              onSearchChange={(e) => props.onSearchChange(e, Constants.TM_VOUCHER_TASKCODE_SEARCH)}
              placeholder={Constants.SEARCH_PLACEHOLDER}
              value={props.taskCodeSearchText}
            />
          </Table.HeaderCell>
          <Table.HeaderCell className="text-left syncedDateTime" >
            <HeaderText text={"Synced Date Time"} />
            <MuiPickersUtilsProvider utils={DateFnsUtils} >
              <KeyboardDatePicker className="date-field"
                disabled={!props.isDatePickerEnabled}
                placeholder="MM/DD/YY"
                clearable
                value={props.tmVoucher && props.selectedSyncDate ? props.selectedSyncDate : null}
                onChange={date => props.handleSyncDateChange(date)}
                inputProps={{ readOnly: true }}
                format="MM/dd/yy"
                inputVariant="outlined"
                {...(props.minDate ? props.minDate : {})}
                {...(props.maxDate ? props.maxDate : {})}
              />
            </MuiPickersUtilsProvider>
          </Table.HeaderCell>
          <Table.HeaderCell className="text-left" style={{ maxWidth: '70px' }}>
            <HeaderText text={"Version"} />
            <Search
              onSearchChange={(e) => props.onSearchChange(e, Constants.TM_VOUCHER_VERSION_SEARCH)}
              placeholder={Constants.SEARCH_PLACEHOLDER}
              value={props.versionSearchText}
            />
          </Table.HeaderCell>
          <Table.HeaderCell className="text-left" style={{ maxWidth: '90px' }}>
            <HeaderText text={"Status"} />
            <Search
              onSearchChange={(e) => props.onSearchChange(e, Constants.TM_VOUCHER_STATUS_SEARCH)}
              placeholder={Constants.SEARCH_PLACEHOLDER}
              value={props.statusSearchText}
            />
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>

        {props.tmVoucher && props.tmVoucher.length > 0 ? props.tmVoucher.map((voucher) => {
          return (
            <Table.Row className="tmVoucherTableRow">
              <Table.Cell>
                <div className="fontSizeVocuher" >
                  {voucher.tmVoucherNumber}
                </div>
              </Table.Cell>

              <Table.Cell>
                <div className="text-center d-flex justify-center">
                  <Checkbox readOnly={true} className="selectedTable mb5 tmVoucherSignatureCheckbox" checked={voucher.hasSignature} />
                </div>
              </Table.Cell>

              <Table.Cell textAlign="center" className="cellTabale">
                <div className="downloadnEyeIcon d-flex align-items-center justify-content-around" >
                  <a onClick={() => { props.onClickDownload(voucher) }} style={{ display: 'inline-flex' }}>
                    <span className="iconify myiconstyle pointerCurser" data-icon="mdi:tray-arrow-down" data-inline="false" ></span>
                  </a>
                  <div style={{ display: 'inline-flex' }} onClick={() => { props.openTMReport(voucher) }}>
                    <span className="iconify myiconstyle pointerCurser" data-icon="mdi:eye-outline" data-inline="false" ></span>
                  </div>
                </div>
              </Table.Cell>

              {/* <Table.Cell textAlign="center"> */}
              <Table.Cell textAlign="center" className={voucher.isAttachmentAdded ? "highlightNotes" : "cellTabale"}>
                <div className="attachIcon" onClick={() => {
                  props.openAttachments({ modalOpenAttachments: true, tmvoucherId: voucher.id, deviceId: voucher.deviceId })
                }}>
                  {/* <Icon name=""> */}
                  <span className="iconify myiconstyle pointerCurser" data-icon="mdi:paperclip" data-inline="false" ></span>
                </div>
              </Table.Cell>

              {!(props.isShowRevisionModal) &&
                <Table.Cell textAlign="center" className="cellTabale">
                  <div className="revisionIcon" onClick={() => {
                    props.openRevisionModal({ deviceId: voucher.deviceId, ProjectId: voucher.projectId, TaskCodeID: voucher.taskCodeID, TMVoucherNumber: voucher.tmVoucherNumber })
                  }}>
                    {/* <span className="iconify myiconstyle pointerCurser" data-icon="mdi:file-document-refresh"
                       data-inline="false" ></span> */}
                    <svg className="pointerCurser revionsionhover" xmlns="http://www.w3.org/2000/svg" version="1.0" width="1.3em" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">
                      <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#f18f40" stroke="none">
                        <path d="M977 4692 c-16 -17 -17 -85 -17 -774 l0 -755 -98 -16 c-332 -54 -610 -260 -757 -562 -75 -153 -96 -238 -102 -413 -6 -164 5 -252 48 -379 113 -334 385 -585 729 -672 46 -11 95 -21 109 -21 14 0 36 -3 49 -6 l22 -6 0 -323 c0 -299 1 -323 18 -338 17 -16 141 -17 1584 -17 1503 0 1566 1 1581 18 15 17 17 55 17 339 l0 321 23 6 c12 3 34 6 48 6 39 0 164 34 255 69 208 80 419 275 526 486 83 162 113 310 105 517 -6 175 -27 260 -102 413 -148 304 -435 514 -773 566 l-82 12 0 757 c0 721 -1 758 -18 773 -17 16 -141 17 -1584 17 -1503 0 -1566 -1 -1581 -18z m3033 -722 l0 -590 -68 0 -67 0 -90 -90 -90 -90 -1175 0 c-1315 0 -1220 5 -1220 -70 0 -30 6 -43 26 -59 27 -21 29 -21 1127 -21 l1100 0 -62 -65 c-59 -61 -63 -68 -59 -105 l4 -40 -1039 0 c-1045 0 -1067 -1 -1089 -34 -15 -22 -8 -76 12 -96 20 -20 33 -20 1141 -20 l1122 0 144 -150 145 -150 69 0 69 0 0 -915 0 -915 -1450 0 -1450 0 0 155 0 155 69 0 69 0 172 180 173 180 1084 0 c798 0 1090 3 1106 11 30 16 37 28 37 71 0 73 77 68 -1087 68 -771 0 -1043 3 -1043 11 0 7 -40 53 -90 103 -49 51 -90 95 -90 99 0 4 512 7 1137 7 1043 0 1138 1 1155 17 26 23 24 84 -3 109 -20 18 -57 19 -1234 22 l-1214 2 -43 49 c-49 57 -79 71 -149 71 l-49 0 0 1345 0 1345 1450 0 1450 0 0 -590z m2 -830 c4 -116 8 -120 130 -131 51 -4 113 -12 138 -18 339 -77 607 -351 676 -690 25 -126 16 -317 -21 -431 -108 -338 -387 -574 -737 -623 l-38 -6 0 128 0 127 63 13 c109 22 219 83 306 169 198 198 245 475 124 732 -28 59 -54 93 -122 160 -123 122 -251 180 -406 183 -101 3 -109 -6 -113 -123 l-4 -90 -34 0 c-30 0 -46 13 -152 123 -65 67 -139 145 -165 173 l-46 51 162 171 c151 160 164 171 199 172 l36 0 4 -90z m-3052 -259 l0 -128 -45 -7 c-25 -3 -76 -18 -113 -32 -178 -71 -313 -215 -373 -395 -20 -62 -24 -94 -24 -194 1 -105 4 -130 28 -199 83 -238 276 -394 525 -425 128 -16 152 6 152 139 l0 80 33 0 c29 0 49 -18 200 -177 l168 -176 -63 -66 c-243 -255 -272 -281 -304 -281 l-32 0 -4 91 c-3 81 -6 93 -27 110 -15 13 -39 19 -70 19 -114 0 -258 37 -376 96 -218 110 -372 292 -450 534 -23 71 -28 108 -32 225 -4 119 -2 153 16 229 23 95 80 227 130 299 129 188 339 327 561 372 109 22 100 33 100 -114z m0 -756 l0 -475 -27 6 c-166 40 -294 153 -353 311 -94 251 51 535 315 619 22 7 46 13 53 13 9 1 12 -100 12 -474z m3339 430 c200 -95 311 -328 256 -540 -43 -165 -166 -297 -324 -345 -35 -11 -65 -20 -67 -20 -2 0 -4 214 -4 476 l0 477 33 -7 c17 -3 65 -22 106 -41z" />
                        <path d="M1350 4363 c-8 -3 -23 -12 -32 -21 -17 -14 -18 -47 -18 -432 0 -411 0 -417 21 -436 21 -18 55 -19 1239 -19 1184 0 1218 1 1239 19 21 19 21 25 21 436 0 411 0 417 -21 436 -20 18 -57 19 -1228 21 -663 1 -1213 -1 -1221 -4z m2320 -453 l0 -310 -1110 0 -1110 0 0 310 0 310 1110 0 1110 0 0 -310z" />
                        <path d="M1317 2452 c-24 -27 -22 -85 4 -108 21 -18 55 -19 1239 -19 1184 0 1218 1 1239 19 27 25 29 86 3 109 -17 16 -118 17 -1244 17 -1174 0 -1226 -1 -1241 -18z" />
                        <path d="M1320 2090 c-12 -12 -20 -33 -20 -55 0 -22 8 -43 20 -55 20 -20 33 -20 1240 -20 1207 0 1220 0 1240 20 12 12 20 33 20 55 0 22 -8 43 -20 55 -20 20 -33 20 -1240 20 -1207 0 -1220 0 -1240 -20z" />
                        <path d="M1705 995 c-32 -31 -33 -74 -2 -103 l23 -22 835 0 836 0 21 23 c29 31 28 72 -3 102 l-24 25 -831 0 -831 0 -24 -25z" />
                      </g>
                    </svg>
                  </div>
                </Table.Cell>}

              <Table.Cell className="text-nowrap">
                <div className="fontSizeVocuher">
                  {props.splitDeviceName(voucher.deviceName)}
                </div>
              </Table.Cell>

              <Table.Cell className="text-nowrap">
                <div className="fontSizeVocuher">
                  {voucher.deviceName}
                </div>
              </Table.Cell>

              <Table.Cell className="divisionNumber">
                <div className="fontSizeVocuher" >
                  {moment(voucher.createdDate).format("MM/DD/YY")}
                </div>
              </Table.Cell>

              <Table.Cell className="text-nowrap">
                <div className="fontSizeVocuher" >
                  {voucher.projectNumber}-{voucher.projectName}
                </div>
              </Table.Cell>

              <Table.Cell className="text-nowrap">
                <div className="fontSizeVocuher" >
                  {voucher.taskNumber}-{voucher.taskName}
                </div>
              </Table.Cell>

              <Table.Cell className="divisionNumber" style={{ textTransform: 'uppercase' }}>
                <div className="fontSizeVocuher" >
                  {moment(new Date(`${voucher.syncedDateTime}Z`)).format("MM/DD/YY hh:mm a")}
                </div>
              </Table.Cell>

              <Table.Cell >
                <div className="text-center fontSizeVocuher" >
                  {voucher.tmVersion}
                </div>
              </Table.Cell>

              <Table.Cell>
                <div className="fontSizeVocuher" >
                  {voucher.submittedMode}
                </div>
              </Table.Cell>
            </Table.Row>
          )
        })
          :
          <Table.Row style={{ width: '100%' }}>
            <Table.Cell colSpan="21">
              <NoResultFound displayMessage={Constants.NO_RESULT_FOUND} />
            </Table.Cell>
          </Table.Row>
        }
      </Table.Body>
    </Table>
  );
}


export default TMVoucherTableComponent;